import store from '@/store'
import mock from '@/services/mock/index'
import { getDataAsTable } from '@/services/functions/getDataAsTable'
import { cloneDeep } from 'lodash'

async function getUploadInvoiceErrors (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const testLines = mock.getInvoiceLines
        resolve(testLines)
      }, 500)
    })
  } else {
    var data = cloneDeep(await store.dispatch('app/getAnnouncement', { link: 'notices/uploaderrors', local: true }))?.params
    return getDataAsTable(data, order, params)
  }
}

export { getUploadInvoiceErrors }
